import React, { useEffect, useState } from 'react';
import { node } from 'prop-types';
import { sponsoredProducts as SponsoredProductsUtil } from 'utils';
import {
    useBaseUrls,
    useFeatureFlags,
    useGTM,
    useListingData,
    usePlatform,
    useUser,
} from 'hooks';
import { sponsoredProductsShape } from 'shapes';
import { Provider } from './SponsoredProductsContext';

const SponsoredProductsProvider = ({ children, data }) => {
    const [
        { hasSponsoredProducts, hasSponsoredProductsHidden },
    ] = useFeatureFlags({
        hasSponsoredProducts: 'relevance.listing.sponsored.products',
        // Reverse ab-test… YEAH !
        hasSponsoredProductsHidden: 'relevance.sponsored.products',
    });
    const platform = usePlatform();

    const { adsInfo, isDataFetched } = data;
    const [, pushToGTM] = useGTM();
    const baseUrls = useBaseUrls();
    const user = useUser();
    const value = {
        state: {
            adsInfo,
            isDataFetched,
        },
        actions: {},
    };

    if (adsInfo?.length)
        pushToGTM({
            event: 'sponsored_products_displayed',
            sponsored_products: adsInfo,
            ads_positions: SponsoredProductsUtil.PRODUCTS_CARDS_POSITIONS,
        });
    const [sponsoredProductsData, setData] = useState(value);
    const { listingData } = useListingData();

    useEffect(() => {
        if (
            !sponsoredProductsData.state.isDataFetched &&
            hasSponsoredProducts &&
            !hasSponsoredProductsHidden &&
            !user.isB2B
        ) {
            SponsoredProductsUtil.fetchAds(
                listingData,
                baseUrls.browser_api,
                platform,
            ).then(result => {
                if (result.adsInfo?.length) {
                    setData({
                        ...sponsoredProductsData,
                        state: {
                            ...sponsoredProductsData.state,
                            adsInfo: result.adsInfo,
                            isDataFetched: true,
                        },
                    });
                    pushToGTM({
                        event: 'sponsored_products_displayed',
                        sponsored_products: result.adsInfo,
                        ads_positions:
                            SponsoredProductsUtil.PRODUCTS_CARDS_POSITIONS,
                    });
                }
            });
        }
    }, []);

    return <Provider value={sponsoredProductsData}>{children}</Provider>;
};

SponsoredProductsProvider.propTypes = {
    children: node,
    data: sponsoredProductsShape,
};

SponsoredProductsProvider.defaultProps = {
    children: null,
    data: {
        adsInfo: [],
        isDataFetched: false,
    },
};

SponsoredProductsProvider.displayName = `SponsoredProductsProvider`;
export default SponsoredProductsProvider;
